import { Badge } from "@/components/ui/badge";
import { isScheduledJob } from "@/utils/jobHelpers";
import type { Job } from "@/utils/types";

/**
 * Props for the JobTypeBadge component.
 */
interface JobTypeBadgeProps {
  /** The job to display a badge for */
  job: Job;
}

/**
 * A badge component that indicates whether a job is scheduled or manual.
 *
 * - Scheduled jobs (from pg_cron) display a "Scheduled" badge with secondary variant
 * - Manual jobs (user-triggered) display a "Manual" badge with outline variant
 *
 * @example
 * ```tsx
 * <JobTypeBadge job={job} />
 * ```
 */
export function JobTypeBadge({ job }: JobTypeBadgeProps) {
  const isScheduled = isScheduledJob(job);

  return (
    <Badge variant={isScheduled ? "secondary" : "outline"} data-testid="job-type-badge">
      {isScheduled ? "Scheduled" : "Manual"}
    </Badge>
  );
}
